<template>
  <div class="services">
    <el-card class="service-box" v-for="service in services" :key="service.id">
      <div slot="header" class="header">
        <span>{{ service.name }}</span>
        <el-button
          type="warning"
          size="small"
          @click="restart(service)"
          v-loading.fullscreen.lock="!!restarting"
          element-loading-background="rgba(255, 255, 255, 0.4)"
          :element-loading-text="
            restarting
              ? `Restarting service ${restarting.name}, please wait...`
              : ''
          "
          >Restart</el-button
        >
      </div>
      <p>
        <b>stage:</b> {{ service.stage }}<br />
        <b>description:</b> {{ service.description || 'none' }}
      </p>
    </el-card>
  </div>
</template>

<style scoped>
.services {
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.service-box {
  width: 250px;
  margin: 10px 10px 0 0;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  methods: {
    ...mapActions('services', ['fetchServices', 'restartService']),
    restart (service) {
      this.restartService(service).then(({ service }) => {
        this.$message({
          message: `Service ${service.name} has been successfully restarted`,
          type: 'success'
        })
      })
    }
  },

  computed: {
    ...mapGetters('services', ['services', 'restarting'])
  },

  mounted () {
    this.fetchServices()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/ServicesManager.vue